import { IAdminStatus } from "@/services/admin-management-service";

interface StatusRadioGroupProps {
  value: IAdminStatus;
  onChange: (value: IAdminStatus) => void;
}

export const StatusRadioGroup = ({ value, onChange }: StatusRadioGroupProps) => {
  const options: { value: IAdminStatus; label: string }[] = [
    { value: "active", label: "Active" },
    { value: "inactive", label: "Inactive" },
  ];

  return (
    <div className="flex gap-2 h-12">
      {options.map(({ value: optVal, label }) => {
        const isActive = value === optVal;
        return (
          <button
            key={optVal}
            type="button"
            onClick={() => onChange(optVal)}
            className={`flex-1 h-full rounded border flex items-center px-4  gap-2 transition-colors  border-[#00000027]
            `}
          >
            <span
              className={`w-5 h-5 rounded border flex items-center justify-center ${
                isActive ? "border-[#202020] bg-[#202020]" : "border-[#00000027]"
              }`}
            >
              {isActive && <span className="w-2 h-2 rounded-full bg-white" />}
            </span>
            <span className="text-base text-[#000000]">{label}</span>
          </button>
        );
      })}
    </div>
  );
};
